import { createFileRoute } from '@tanstack/react-router';
import { ApprovalRulesPage } from '@/features/action-approvals/pages/rules-page';

export const Route = createFileRoute('/_app/settings/approvals')({ component: ApprovalRulesPage });
